import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem
} from '@ttab/elephant-ui'
import type { YDocument } from '@/modules/yjs/hooks'
import { useYValue } from '@/modules/yjs/hooks'
import type * as Y from 'yjs'
import { Block } from '@ttab/elephant-api/newsdoc'
import { useEditorialInfoTypes } from '../hooks/useEditorialInfoType'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

export const EditorialInfoTypes = ({ ydoc }: {
  ydoc: YDocument<Y.Map<unknown>>
}): JSX.Element => {
  const [type, setType] = useYValue<Block | undefined>(
    ydoc.ele,
    'links.tt/editorial-info-type[0]'
  )
  const { t } = useTranslation('metaSheet')

  const editorialInfoTypes = useEditorialInfoTypes()
  const onValueChange = (value: string) => {
    if (value === 'empty') {
      setType(undefined)
      return
    }

    const editorialInfoBlock = Block.create({
      uuid: value,
      type: 'tt/editorial-info-type',
      rel: 'info-type'

    })

    setType(editorialInfoBlock)
  }

  return (
    <Select
      onValueChange={onValueChange}
      name='EditorialInfoType'
      value={type?.uuid || 'empty'}
    >
      <SelectTrigger>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {[{ id: 'empty', title: t('misc.noType') }, ...editorialInfoTypes]?.map((item) =>
          <SelectItem key={item.id} value={item.id}>{item.title}</SelectItem>
        )}
      </SelectContent>
    </Select>
  )
}
